import queryString from "query-string";

const ALLOW_QUERY_PARAM = "enable_mobile";
const DISALLOW_QUERY_PARAM = "disable_mobile";

function allowMobileMode(isAllowed) {
	// Add the appropriate query param.
	const queryParams = {
		...(queryString.parse(window.location.search)),
		[isAllowed ? ALLOW_QUERY_PARAM : DISALLOW_QUERY_PARAM]: 1,
	};

	// Delete the other thing, in case it's in there.
	delete queryParams[isAllowed ? DISALLOW_QUERY_PARAM : ALLOW_QUERY_PARAM];

	// Redirect!
	window.location.href = `${window.location.origin}${window.location.pathname}?${queryString.stringify(queryParams)}`;
}

export default allowMobileMode;



// WEBPACK FOOTER //
// ./src/shared/util/allowMobileMode.js